import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import withModal from '../../../../../../../../components/global/modal/withModal';
import { USERPAGE_PRO_ONBOARDING_MODAL } from '../../../../../../../../constants/modals';
import ProOnboardingCTA from './ProOnboardingCTA';

const ProOnboardingCTAModal = compose(withRouter, withModal)(ProOnboardingCTA, {
  className: 'pro-onboarding-modal',
  name: USERPAGE_PRO_ONBOARDING_MODAL,
  size: 'md',
  type: 'full',
});

export default ProOnboardingCTAModal;
